// Mock data for Housypoint clone

export const heroSlides = [
  {
    id: 1,
    image: '/mock_images/static1_1.png',
    alt: 'Sell offer',
  },
  {
    id: 2,
    image: '/mock_images/Web_New2.png',
    alt: 'Rent offer',
  },
  {
    id: 3,
    image: '/mock_images/Web_New3.png',
    alt: 'Home loan offer',
  },
];

export const cities = ['Gurgaon', 'Bangalore', 'Mumbai', 'Pune', 'Goa', 'Delhi', 'Noida', 'Hyderabad'];

export const residentialConfigs = [
  { label: '5.5/5 BHK', count: 1, key: 'four' },
  { label: '4.5/4 BHK', count: 14, key: 'four' },
  { label: '3.5/3 BHK', count: 171, key: 'three' },
  { label: '2.5/2 BHK', count: 91, key: 'two' },
  { label: '1 BHK', count: 4, key: 'one' },
  { label: 'Studio', count: 0, key: 'studio' },
];

export const commercialConfigs = [
  { label: 'Office Space', key: 'Office Space' },
  { label: 'Shop', key: 'Shop' },
  { label: 'Food Court', key: 'Food Court' },
  { label: 'Studio', key: 'Studio', count: 0 },
  { label: 'Hotel', key: 'Hotel' },
  { label: 'Restaurant', key: 'Restaurant' },
];

export const services = [
  { title: 'Legal', subtitle: 'Get Legal Advice', img: '/mock_images/Law.png' },
  { title: 'Taxation', subtitle: 'Get CA/CS Advice', img: '/mock_images/CA.png' },
  { title: 'Home Inspection', subtitle: 'Get Inspection', img: '/mock_images/inspection_service.png' },
  { title: 'Home Loan', subtitle: 'Apply Home Loan', img: '/mock_images/loan_service.png' },
];

export const distressDealsResale = [
  {
    id: 1,
    name: 'Godrej Splendour',
    builder: 'Godrej',
    builderLogo: '/mock_images/godrej-logo.png',
    image: '/mock_images/9e541273-1bbe-4e8c-87df-e56002d2d6a1.webp',
    type: 'apartment',
    facing: 'North East Facing',
    furnishing: 'raw',
    status: 'Under Construction',
    bhk: '2 BHK',
    location: 'Whitefield, Bengaluru',
    sqft: '981 sqft',
    floor: '18 Floor',
    price: '₹92.00 L',
    negotiable: true,
  },
  {
    id: 2,
    name: 'Eldeco Acclaim',
    builder: 'Eldeco Group',
    builderLogo: '/mock_images/eldeco_logo.png',
    image: '/mock_images/1_1YrfpR9.PNG',
    type: 'apartment',
    facing: 'North Facing',
    furnishing: 'raw',
    status: 'Under Construction',
    bhk: '2 BHK',
    location: 'Sohna Rural, Gurgaon',
    sqft: '1269 sqft',
    floor: '3 Floor',
    price: '₹2.00 Cr',
    negotiable: true,
  },
  {
    id: 3,
    name: 'M3M Soulitude',
    builder: 'M3M',
    builderLogo: '/mock_images/m3m-logo-350x350.webp',
    image: '/mock_images/pic_1_wrweZV2.jpg',
    type: 'apartment',
    facing: 'East Facing',
    furnishing: 'raw',
    status: 'Under Construction',
    bhk: '3.5 BHK',
    location: 'Sector 89, Gurgaon',
    sqft: '1494 sqft',
    floor: '4 Floor',
    price: '₹2.90 Cr',
    oldPrice: '3.2 Cr',
    negotiable: true,
  },
  {
    id: 4,
    name: 'Smartworld Orchard',
    builder: 'Smartworld',
    builderLogo: '/mock_images/logo1.webp',
    image: '/mock_images/smartworld2.png',
    type: 'apartment',
    facing: 'East Facing',
    furnishing: 'raw',
    status: 'Under Construction',
    bhk: '2.5 BHK',
    location: 'Sector 61, Gurgaon',
    sqft: '1150 sqft',
    floor: '3 Floor',
    price: '₹1.80 Cr',
    oldPrice: '2.3 Cr',
    negotiable: true,
  },
  {
    id: 5,
    name: 'DLF Garden City',
    builder: 'DLF',
    builderLogo: '/mock_images/dlf.webp',
    image: '/mock_images/dlf-garden-city-enclave-independent-floors-exquisite-design-and-unmatched-luxury.jpg',
    type: 'floor',
    facing: 'North Facing',
    furnishing: 'semi-furnished',
    status: 'Under Construction',
    bhk: '3 BHK',
    location: 'Sector 92, Gurgaon',
    sqft: '1620 sqft',
    floor: '1 Floor',
    price: '₹1.95 Cr',
    negotiable: false,
  },
  {
    id: 6,
    name: 'M3M Crown',
    builder: 'M3M',
    builderLogo: '/mock_images/m3m-logo-350x350.webp',
    image: '/mock_images/slide2.jpg',
    type: 'apartment',
    facing: 'North East Facing',
    furnishing: 'raw',
    status: 'Under Construction',
    bhk: '3.5 BHK',
    location: 'Sector 111, Gurgaon',
    sqft: '1825 sqft',
    floor: '15 Floor',
    price: '₹3.05 Cr',
    negotiable: true,
  },
  {
    id: 7,
    name: 'Krisumi Waterfall',
    builder: 'Krisumi Corporation',
    builderLogo: '/mock_images/logo_2zWCSqe.png',
    image: '/mock_images/TowerCdropOff.jpg',
    type: 'apartment',
    facing: 'East Facing',
    furnishing: 'semi-furnished',
    status: 'Under Construction',
    bhk: '3.5 BHK',
    location: 'Sector 36A, Gurgaon',
    sqft: '2503 sqft',
    floor: '9 Floor',
    price: '₹4.90 Cr',
    negotiable: true,
  },
  {
    id: 8,
    name: 'SS Cendana',
    builder: 'SS Group',
    builderLogo: '/mock_images/SS%20logo.webp',
    image: '/mock_images/vz.webp',
    type: 'apartment',
    facing: 'East Facing',
    furnishing: 'raw',
    status: 'Under Construction',
    bhk: '3.5 BHK',
    location: 'Sector 83, Gurgaon',
    sqft: '861 sqft',
    floor: '8 Floor',
    price: '₹1.75 Cr',
    negotiable: true,
  },
];

export const distressDealsRent = [
  {
    id: 9,
    name: 'M3M Soulitude',
    builder: 'M3M',
    builderLogo: '/mock_images/m3m-logo-350x350.webp',
    image: '/mock_images/pic_1_wrweZV2.jpg',
    type: 'floor',
    facing: 'East Facing',
    furnishing: 'raw',
    status: 'Under Construction',
    bhk: '3.5 BHK',
    location: 'Sector 89, Gurgaon',
    sqft: '1494 sqft',
    floor: '4 Floor',
    price: '₹35.00 K',
  },
  {
    id: 10,
    name: 'Central Park Golf Course Road',
    builder: 'Central Park',
    builderLogo: '/mock_images/centralparklogo.png',
    image: '/mock_images/Golf1.jpg',
    type: 'apartment',
    facing: 'East Facing',
    furnishing: 'raw',
    status: 'Under Construction',
    bhk: '3 BHK',
    location: 'Golf Course Rd, Gurgaon',
    sqft: '2000 sqft',
    floor: '6 Floor',
    price: '₹1.20 L',
  },
  {
    id: 11,
    name: 'Emaar DigiHomes',
    builder: 'Emaar',
    builderLogo: '/mock_images/download.png',
    image: '/mock_images/HI-8-1620x832.jpg',
    type: 'apartment',
    facing: 'East Facing',
    furnishing: 'semi-furnished',
    status: 'Under Construction',
    bhk: '2 BHK',
    location: 'Golf Course Ext, Gurgaon',
    sqft: '1508 sqft',
    floor: '—',
    price: '₹60.00 K',
  },
  {
    id: 12,
    name: 'ROF Amaltas',
    builder: 'ROF',
    builderLogo: '/mock_images/rof%20mainlogo.webp',
    image: '/mock_images/slider-11.webp',
    type: 'apartment',
    facing: 'East Facing',
    furnishing: 'raw',
    status: 'Under Construction',
    bhk: '2.5 BHK',
    location: 'Sector 91, Gurgaon',
    sqft: '645 sqft',
    floor: '3 Floor',
    price: '₹30.00 K',
  },
  {
    id: 13,
    name: 'M3M Heights',
    builder: 'M3M',
    builderLogo: '/mock_images/m3m-logo-350x350.webp',
    image: '/mock_images/jnk.JPG',
    type: 'apartment',
    facing: 'East Facing',
    furnishing: 'semi-furnished',
    status: 'Ready to Move',
    bhk: '2.5 BHK',
    location: 'Sector 65, Gurgaon',
    sqft: '1516 sqft',
    floor: '35 Floor',
    price: '₹70.00 K',
  },
];

export const distressDealsCommercial = [
  {
    id: 14,
    name: 'M3M Capital Walk',
    builder: 'M3M',
    builderLogo: '/mock_images/m3m-logo-350x350.webp',
    image: '/mock_images/pic_1_uFTCpWZ.jpg',
    type: 'shop',
    facing: 'North West Facing',
    furnishing: 'wareshell',
    status: 'Under Construction',
    bhk: 'Retail',
    location: 'Sector 113, Gurgaon',
    sqft: '240 sqft',
    floor: 'UG Floor',
    price: '₹90.00 L',
    negotiable: true,
  },
  {
    id: 15,
    name: 'ROF Normanton Mall',
    builder: 'ROF',
    builderLogo: '/mock_images/rof%20mainlogo.webp',
    image: '/mock_images/normanton.webp',
    type: 'shop',
    facing: 'East Facing',
    furnishing: 'wareshell',
    status: 'Under Construction',
    bhk: 'Retail',
    location: 'Sector 36, Gurgaon',
    sqft: '372 sqft',
    floor: 'G Floor',
    price: '₹55.80 L',
    negotiable: true,
  },
  {
    id: 16,
    name: 'M3M Paragon 57',
    builder: 'M3M',
    builderLogo: '/mock_images/m3m-logo-350x350.webp',
    image: '/mock_images/p1_5qoJzqN.jpg',
    type: 'food court',
    facing: 'North Facing',
    furnishing: 'wareshell',
    status: 'Under Construction',
    bhk: 'Food Court',
    location: 'Sector 57, Gurgaon',
    sqft: '708 sqft',
    floor: '3 Floor',
    price: '₹1.56 Cr',
    negotiable: true,
  },
  {
    id: 17,
    name: 'AIPL Joy Central',
    builder: 'Aipl',
    builderLogo: '/mock_images/logo_VFVMih3.png',
    image: '/mock_images/1_9ONkGUL.webp',
    type: 'shop',
    facing: 'South Facing',
    furnishing: 'wareshell',
    status: 'Ready to Move',
    bhk: 'Retail',
    location: 'Sector 65, Gurgaon',
    sqft: '507 sqft',
    floor: 'G Floor',
    price: '₹2.28 Cr',
    negotiable: true,
  },
];

export const newLaunches = [
  { id: 1, name: 'Godrej Zenith', location: 'Gurgaon, Sector 89', price: '2.19*', img: '/mock_images/njkn_5S9KlEB.JPG', logo: '/mock_images/godrej-logo.png' },
  { id: 2, name: 'Godrej Nature Plus Serenity', location: 'Gurgaon, Sohna', price: '1.07*', img: '/mock_images/c996e71a-0b53-48ad-b95b-825e71e908fd.webp', logo: '/mock_images/godrej-logo.png' },
  { id: 3, name: 'Central Park Bignonia Tower', location: 'Gurgaon, Sohna', price: '6*', img: '/mock_images/bignonia_tower_slider_01.webp', logo: '/mock_images/centralparklogo.png' },
  { id: 4, name: 'Eldeco Fairway Reserve', location: 'Gurgaon, Sector 80', price: '3.37 Cr*', img: '/mock_images/rtrtgrww.JPG', logo: '/mock_images/eldeco_logo.png' },
  { id: 5, name: 'Elan The Emperor', location: 'Gurgaon, Dwarka Expressway', price: '9.0 Cr*', img: '/mock_images/4_9P0kzlh.webp', logo: '/mock_images/logo.png' },
  { id: 6, name: 'Eldeco Paradiso', location: 'Panipat', price: '1.50 Cr*', img: '/mock_images/1_fJ8OnRi.png', logo: '/mock_images/eldeco_logo.png' },
  { id: 7, name: 'Elan Imperial', location: 'Gurgaon, Sector 82', price: '1.89 Cr*', img: '/mock_images/1_76lUnf0.PNG', logo: '/mock_images/logo.png' },
  { id: 8, name: 'DLF Privana North', location: 'Gurgaon, Sector 76', price: '9.5 Cr*', img: '/mock_images/Screenshot_2025-06-08_at_5.10.21PM.png', logo: '/mock_images/dlf.webp' },
  { id: 9, name: 'Conscient Elevate Reserve', location: 'Gurgaon, Sector 62', price: '6.59*', img: '/mock_images/parq-1_1snUa7a.webp', logo: 'https://housymediabucket.blr1.cdn.digitaloceanspaces.com/media/builder_images/logo.webp' },
  { id: 10, name: 'Central Park Bellavista Towers', location: 'Gurgaon, Sohna', price: '3.02*', img: '/mock_images/bellaprojec4.jpg', logo: '/mock_images/centralparklogo.png' },
  { id: 11, name: 'Godrej Miraya', location: 'Gurgaon, Golf Course Rd', price: '9.29*', img: '/mock_images/banner_Z80Fzcw.jpg', logo: '/mock_images/godrej-logo.png' },
  { id: 12, name: 'Godrej Vrikshya', location: 'Gurgaon, Sector 103', price: '4.88*', img: '/mock_images/banner-left.jpg', logo: '/mock_images/godrej-logo.png' },
];

export const inspectionPlans = [
  {
    id: 1,
    name: 'Pro',
    price: 5999,
    originalPrice: 19999,
    features: [
      'Tile finish check',
      'Door alignment & function',
      'Paint defect inspection',
      'All Electrical fittings inspection',
      'Bathroom fittings check',
      'Slope check',
      'Leakages detection',
      'Thermal Imaging for Paint Dampness',
      'Room area measurement inch-by-inch',
      'Comprehensive report',
    ],
  },
  {
    id: 2,
    name: 'Advanced',
    price: 9999,
    originalPrice: 24999,
    highlighted: true,
    features: [
      'Tile finish check',
      'Door alignment & function',
      'Paint defect inspection',
      'All Electrical fittings inspection',
      'Bathroom fittings check',
      'Slope check',
      'Leakages detection',
      'Thermal Imaging for Paint Dampness',
      'Room area measurement inch-by-inch',
      'Comprehensive report',
      'Re-visit to ensure corrections',
    ],
  },
];

export const loanBanks = [
  '/mock_images/PNB_WEB.png',
  '/mock_images/KOTAK_WEB.png',
  '/mock_images/HDFC_WEB.png',
  '/mock_images/ICICI_WEB.png',
];

export const popularCities = [
  { name: 'Gurgaon', state: 'HARYANA', count: 302, img: '/mock_images/gurgaon.jpg' },
  { name: 'Bangalore', state: 'KARNATAKA', count: 2, img: '/mock_images/bangalore.jpg' },
  { name: 'Mumbai', state: 'MAHARASHTRA', count: 6, img: '/mock_images/mumbai.jpg' },
  { name: 'Pune', state: 'MAHARASHTRA', count: 8, img: '/mock_images/pune.jpg' },
  { name: 'Goa', state: 'GOA', count: 0, img: '/mock_images/goa.jpg' },
];

export const trustedDevelopers = [
  { name: 'M3M', logo: '/mock_images/m3m-logo-350x350.webp' },
  { name: 'Smartworld', logo: '/mock_images/logo1.webp' },
  { name: 'Godrej', logo: '/mock_images/godrej-logo.png' },
  { name: 'Adani', logo: '/mock_images/adani_realty.png' },
  { name: 'Aipl', logo: '/mock_images/logo_VFVMih3.png' },
  { name: 'Anant Raj', logo: '/mock_images/loho.png' },
  { name: 'Ashiana', logo: '/mock_images/Ashiana-Builder-350x350.jpg' },
  { name: 'Bestech', logo: '/mock_images/bestech-logo.png' },
  { name: 'Birla Estates', logo: '/mock_images/birla-estate-logo.webp' },
  { name: 'BPTP', logo: '/mock_images/logo_L2flEVG.png' },
  { name: 'Central Park', logo: '/mock_images/centralparklogo.png' },
  { name: 'Conscient', logo: 'https://housymediabucket.blr1.cdn.digitaloceanspaces.com/media/builder_images/logo.webp' },
  { name: 'DAMAC', logo: 'https://housymediabucket.blr1.cdn.digitaloceanspaces.com/media/builder_images/dvv.webp' },
  { name: 'DLF', logo: '/mock_images/dlf.webp' },
  { name: 'Elan', logo: '/mock_images/logo.png' },
  { name: 'Eldeco', logo: '/mock_images/eldeco_logo.png' },
  { name: 'Emaar', logo: '/mock_images/download.png' },
  { name: 'Experion', logo: '/mock_images/experion-footer.png' },
  { name: 'Ganga Realty', logo: '/mock_images/ganga-footer-logo.jpg' },
  { name: 'Ireo', logo: '/mock_images/logooo.webp' },
  { name: 'Krisumi', logo: '/mock_images/logo_2zWCSqe.png' },
  { name: 'ROF', logo: '/mock_images/rof%20mainlogo.webp' },
  { name: 'Shree Vardhman', logo: '/mock_images/shree-vardhman-logo.png' },
  { name: 'SS Group', logo: '/mock_images/SS%20logo.webp' },
  { name: 'Signature Global', logo: '/mock_images/340.png' },
  { name: 'Sobha', logo: '/mock_images/sr-logo.jpg' },
  { name: 'Tulip', logo: '/mock_images/log.webp' },
  { name: 'White Land', logo: '/mock_images/Logo%20(3).webp' },
];
